import {
  // filterMode,
  // typeIcons,
  getFilterIcon
} from '../../common/filter-mode';

require('./catalog-view-node.component.scss');

class CatalogViewNodeController {
  constructor(
    $q,
    $scope,
    FilterEditorService,
    FilterCardEditorModalService,
    FilterDataFactory,
    PermissionService,
    RouterService,
    LayoutService,
    CatalogNodeDragService
  ) {
    this.$q = $q;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.filterData = FilterDataFactory();
    this.permission = PermissionService;
    this.router = RouterService;
    this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.showReport = this.layout.openAll;
    // this.searchedFilters = CatalogNodeDragService.searchedFilters;
    $scope.$watch('$ctrl.layout.openAll', () => this.showReport = this.layout.openAll > 0);
  }

  $postLink() {
    this.showReport = this.filter && this.filter.isCatalog;
  }

  get isEditCatalog() {
    return this.layout.editCatalog;
  }

  get filterIcon() {
    return getFilterIcon(this.filter);
  }

  get filter() {
    return this._filter;
  }

  get isEditFilter() {
    // return true;
    return this.permission.policies && (this.permission.filterConstructor ||
      this.filter.isPolitic);
  }

  set filter(filter) {
    this._filter = filter;
    this.filterData.update(filter);
  }

  toggle() {
    this.showReport = !this.showReport;
  }

  needToShowFilter(filter) {
    if (!this.layout.searchedFilters.all) {
      if (this.layout.searchedFilters[filter.id]) {
        this.showReport = true;
        return true;
      } else return false;
    }
    return true;
  }

  editFilter() {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew: false,
      selectFilter: false,
    });
  }

}

export const CatalogViewNodeComponent = {
  template: require('./catalog-view-node.component.html'),
  bindings: {
    index: '<',
    model: '<',
    filter: '<',
    // filterBar: '<',
  },
  controller: CatalogViewNodeController,
};



// WEBPACK FOOTER //
// ./src/view/catalog/catalog-view-node.component.js